export const customStyle = (styles: string) => {
  return `${styles}`
}
